"use client"
import React from "react"
import { motion } from "framer-motion"
import { PiGearBold } from "react-icons/pi"
import { useAppSelector } from "@/app/redux/hooks/reduxHooks"
import ReactLoading from "react-loading"
import Link from "next/link"

export const DashboardHeaderComponent = () => {
    const auth = useAppSelector((state) => state.auth)
    return (
        <section className="relative z-10">
            {auth.username === null ? (
                <ReactLoading type={"balls"} color={"#fff"} height={24} width={24} />
            ) : (
                <div className="flex">
                    <h2 className="font-thin mr-1">Welcome back, {auth.username}</h2>
                    <motion.span
                        initial={{ rotate: 0, transformOrigin: "center", zIndex: 10 }}
                        whileHover={{ rotate: 90, transformOrigin: "center", transition: { duration: 0.25 } }}
                    >
                        <Link href="/auth/account">
                            <PiGearBold className="w-full h-full hover:text-primary hover:cursor-pointer" />
                        </Link>
                    </motion.span>
                </div>
            )}
            <h1 className="text-[30px] text-shadow-md">PORTAL DASHBOARD</h1>
        </section>
    )
}
